import coralRightType2 from '../../assets/new-ui/coral/coral-right-type-2.gif'

export default function CoralRightType2() {

  return (
    <div className='coralGif coralRightType2' >
      <img src={coralRightType2} alt='coral gif' />
    </div>
  )
}